import { Link } from "react-router-dom";
import logo from "@/assets/brema-logo.svg";

export function BremaLogo({ compact = false, className = "", imgClassName = "" }) {
  return (
    <Link to="/" data-testid="brand-logo" className={`group inline-flex items-center ${className}`}>
      <img
        src={logo}
        alt="Brema Bike"
        className={`w-auto transition-transform duration-200 group-hover:scale-105 ${imgClassName || (compact ? "h-9" : "h-14")}`}
      />
    </Link>
  );
}
